import React from 'react';
import "./ToolPalette.css"
import { IconButton } from '@mui/material';
import { AddToPhotos, DisabledByDefault, FolderOpen, Publish, Redo, Save, Undo } from '@mui/icons-material';
import FloorSelector from './FloorSelector';
import ShapeToolPalette from './ShapeToolPalette';

function ToolPalette(props) {
	return (<div className="bd-tool-palette-outer">
		<IconButton className="bd-tool-button" title="Save" size="small" onClick={ props.onSaveClick }>
			<Save fontSize="small" />
		</IconButton>

		<IconButton className="bd-tool-button" title="Load" size="small" onClick={ props.onLoadClick }>
			<FolderOpen fontSize="small" />
		</IconButton>

		<IconButton disabled={ !props.canUndo } className="bd-tool-button" title="Undo" size="small" onClick={ props.onUndoClick }>
			<Undo fontSize="small" />
		</IconButton>

		<IconButton disabled={ !props.canRedo } className="bd-tool-button" title="Redo" size="small" onClick={ props.onRedoClick }>
			<Redo fontSize="small" />
		</IconButton>

		<FloorSelector 
		activeBuildingIndex={ props.activeBuildingIndex } 
		buildingNames={ props.buildingNames } 
		building={ props.activeBuilding }
		editingFloor={ props.editingFloor }
		onFloorClick={ props.onFloorClick } />
		<div>
			<IconButton className="bd-tool-button" title="Add floor" onClick={ props.onAddFloorClick }>
				<AddToPhotos />
			</IconButton>

			<IconButton className="bd-tool-button" title="Remove floor" onClick={ props.onRemoveFloorClick }>
				<DisabledByDefault />
			</IconButton>

			<IconButton className="bd-tool-button" title="Change altitude" onClick={ props.onChangeAltitudeClick }>
				<Publish />
			</IconButton>
		</div>
		<ShapeToolPalette
			onAddPolygonClick={ props.onAddPolygonClick }
			onAddNodeClick={ props.onAddNodeClick }
			onAddElevatorClick={ props.onAddElevatorClick }
			onAddStairsClick={ props.onAddStairsClick }
		/>
	</div>);
}

export default ToolPalette;
